import type { BaseFile } from 'config'
import { accountTypes } from 'config/user.type.constants'
import { ActionType } from 'pages/Admin/AdminTools/Configuration/LoanSubmission/types'
import type { UserInfo } from 'pages/ManageAccounts'

export enum TaskStatus {
  ACTIVE = 'active',
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  OVERDUE = 'overdue',
}
export const taskProjectLoanNumber = {
  BrokerVerification: 1,
  FundDrawRequest: 2,
  Reminders: 3,
  LoanScenarios: 4,
}

export const taskProjectID = {
  DefaultProjectId: 1,
  BrokerVerification: 2,
  FundDrawRequest: 3,
  Reminders: 4,
  LoanScenarios: 5,
}

export const NonLoanTaskProjectIds = [
  taskProjectID.BrokerVerification,
  taskProjectID.FundDrawRequest,
  taskProjectID.Reminders,
  taskProjectID.LoanScenarios,
]

export const TaskAssigneeOptions = (): Record<string, string> => ({
  self_underwriter: '[Loan] Underwriter',
  self_account_executive: '[Loan] Account Executive',
  self_broker: '[Loan] Broker',
  self_loan_officer: '[Loan] Loan Officer',
  self_loan_processor: '[Loan] Loan Processor',
  self_account_manager: '[Loan] Account Manager',
  self_creator: '[Loan] Creator',
  ...accountTypes,
})

export const EmailAssigneeOptions = (accountType?: ActionType): Record<string, string> => {
  if (accountType == ActionType.UserAccounts)
    return {
      self_user: '[User] Individual User',
      ...accountTypes,
    }

  return {
    self_underwriter: '[Loan] Underwriter',
    self_account_executive: '[Loan] Account Executive',
    self_broker: '[Loan] Broker',
    self_loan_officer: '[Loan] Loan Officer',
    self_loan_processor: '[Loan] Loan Processor',
    self_account_manager: '[Loan] Account Manager',
    self_creator: '[Loan] Creator',
    loan_borrower: '[Loan] Borrower',
    ...accountTypes,
  }
}

export interface Project {
  id: number

  name: string

  user: UserInfo

  createdAt: Date

  updatedAt: Date
}

export interface TaskAssignedTo {
  id: number

  task: Task

  value: string

  createdAt: Date
}

export interface Task {
  id: number

  project: Project

  assignedTo: TaskAssignedTo[]

  assignedToManager: TaskAssignedTo[]

  loanNumber: number

  byteproFileName: number

  no: number

  taskTemplateNo: number

  byteproTaskID: number

  borrowerName: string

  description: string

  dueDate: string

  note: string

  files: BaseFile[]

  status: TaskStatus

  creator: UserInfo

  completor: UserInfo

  completedDate: string

  additionalInfo: Record<string, string | number>

  deleted: boolean

  createdAt: Date

  updatedAt: Date
}
